@if (viewStateLoaded()) {
    <button
        mat-icon-button
        [matTooltip]="languageSettings.PSTWebSaveViewSettings"
        [matMenuTriggerFor]="menu">
        <mat-icon class="material-symbols-outlined">save_as</mat-icon>
    </button>

    <mat-menu
        #menu="matMenu"
        class="st-discover-secondary-cta-menu">
        <ng-template matMenuContent>
            @if (saveViewSettingsEnabled()) {
                <button
                    mat-menu-item
                    (click)="saveViewState()">
                    {{ languageSettings.PSTWebSaveViewSettings }}
                </button>
            }
        </ng-template>
    </mat-menu>
}
